import { Skeleton,Typography } from '@material-ui/core';
export default function Renderskeleton(props: { loading?: boolean }) {
  const { loading = false } = props;
  return (
    <div>
        {
            loading ?
            <Typography component="div">
                <Skeleton variant="text" width={250} height={110} />
                <Skeleton variant='text' width={250} height={3} />
                <Skeleton variant="text" width={150} height={45} />
                <Skeleton variant="text" width={250} height={35} />
                <Skeleton variant="text" width={250} height={35} />
                <Skeleton variant="text" width={150} height={45} />
                <Skeleton variant="text" width={250} height={35} />
                <Skeleton variant="text" width={250} height={35} />
                <Skeleton variant="text" width={250} height={35} />
                <Skeleton variant="text" width={250} height={35} />
                <Skeleton variant="text" width={250} height={35} />
                <Skeleton variant="text" width={250} height={35} />
                <Skeleton variant="text" width={250} height={35} />
                <Skeleton variant="text" width={250} height={35} />
                <Skeleton variant="text" width={250} height={35} />
                <Skeleton variant="text" width={250} height={35} />
                <Skeleton variant="text" width={250} height={35} />
                <Skeleton variant="text" width={250} height={35} />
                <Skeleton variant="text" width={150} height={45} />
                <Skeleton variant="text" width={250} height={35} />
                <Skeleton variant="text" width={250} height={35} />
            </Typography> :""
        }
    </div>
  );
}